import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Loader2, CheckCircle, XCircle } from 'lucide-react';
import { Button } from './ui/button';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const VerifyEmail = ({ token }) => {
  const hasProcessed = useRef(false);
  const navigate = useNavigate();
  const { setUserData } = useAuth();
  const [status, setStatus] = useState('verifying'); // verifying | success | error
  const [errorMsg, setErrorMsg] = useState('');

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const verify = async () => {
      try {
        const resp = await fetch(`${API}/auth/verify-email`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          credentials: 'include',
          body: JSON.stringify({ token }),
        });
        const data = await resp.json();
        if (!resp.ok) throw new Error(data.detail || 'Verification failed');
        setUserData(data);
        setStatus('success');
        setTimeout(() => {
          navigate('/app', { replace: true });
        }, 2000);
      } catch (err) {
        setStatus('error');
        setErrorMsg(err.message);
      }
    };

    verify();
  }, [token, navigate, setUserData]);

  return (
    <div className="min-h-screen bg-slate-950 flex items-center justify-center p-4">
      <div className="text-center max-w-sm">
        {status === 'verifying' && (
          <>
            <Loader2 className="w-10 h-10 text-purple-400 animate-spin mx-auto mb-4" />
            <p className="text-white/60 text-sm">Verifying your email...</p>
          </>
        )}
        {status === 'success' && (
          <>
            <CheckCircle className="w-12 h-12 text-emerald-400 mx-auto mb-4" />
            <h2 className="text-white text-xl font-semibold mb-2">Email Verified!</h2>
            <p className="text-white/50 text-sm">Redirecting you to the app...</p>
          </>
        )}
        {status === 'error' && (
          <>
            <XCircle className="w-12 h-12 text-red-400 mx-auto mb-4" />
            <h2 className="text-white text-xl font-semibold mb-2">Verification Failed</h2>
            <p className="text-white/50 text-sm mb-4">{errorMsg}</p>
            <Button
              onClick={() => navigate('/app', { replace: true })}
              className="bg-purple-600 hover:bg-purple-700 text-white text-sm"
            >
              Go to App
            </Button>
          </>
        )}
      </div>
    </div>
  );
};

export default VerifyEmail;
